const DEFAULT_CURRENCY = "$";
const DEFAULT_NO_VALUE = "--";
const DEFAULT_NUMBER_PRECISION = 2;

export { DEFAULT_CURRENCY, DEFAULT_NO_VALUE, DEFAULT_NUMBER_PRECISION };
